import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyD2LTtu5Itqkp2uI5KSyRuV-ye7LLwsq1o",
  authDomain: "edupractice-db513.firebaseapp.com",
  projectId: "edupractice-db513",
  storageBucket: "edupractice-db513.firebasestorage.app",
  messagingSenderId: "628915121033",
  appId: "1:628915121033:web:d190fa79fcb2ecee5b4f58",
  measurementId: "G-2PC25P9VPD"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);